import { useContext } from 'react';

import { type UIConfig } from '../../../types';

import { uiConfig } from './uiConfig';

export const useUIConfig = (): UIConfig => useContext(uiConfig);
